import React from 'react';
import { Glyphicon, FormGroup } from 'react-bootstrap';
import { Label } from 'fw/components';
import { TextBox } from 'fw/forms';

class SecurityQuestions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: props.visible,
            securityResponses: []
        };
    }

    componentDidMount() {
        this.setState({
            securityResponses: this.props.securityQuestions.map((q) => {
                return {
                    question: q.text,
                    securityQuestionId: q.securityQuestionId,
                    response: ""
                }
            })
        });
    }

    onChange = () => {
        if (this.props.onChange !== undefined)
            this.props.onChange(this.state.securityResponses);
    }

    onResponseChange = (index, value) => {
        this.setState({
            securityResponses: this.state.securityResponses.map((sr, i) => {
                return (i === index) ? {
                    question: sr.question,
                    securityQuestionId: sr.securityQuestionId,
                    response: value } : sr
            })
        }, this.onChange);
    }

    render() {
        if (this.props.securityQuestions == null || this.props.securityQuestions.length === 0) {
            return <div />;
        }
        
        const Questions = this.state.securityResponses.map((sr, index) => {
            return (
                <div key={sr.securityQuestionId}>
                    <Label htmlFor="securityQuestion" required>{sr.question}</Label>
                    <TextBox
                        name="securityQuestion"
                        value={sr.response}
                        onChange={(value) => this.onResponseChange(index, value)} required />
                </div>
            );
        });

        return (
            <FormGroup>
                <h4><Glyphicon glyph="menu-right" /> Please answer the security questions below</h4>
                {Questions}
            </FormGroup>
        );
    }
}

export default SecurityQuestions


// WEBPACK FOOTER //
// ./src/areas/public/restorePassword/SecurityQuestions.js